export default __webpack_public_path__ + "static/media/Sneha Jain.6773f0fb.jpeg";